module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.03b68457.jpeg";